import {LitElement, html, css, svg} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('obi-alerts-shelf')
export class ObiAlertsShelf extends LitElement {
  @property({type: Boolean}) useCssColor = false;

  private icon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M18 23C16.6167 23 15.4375 22.5125 14.4625 21.5375C13.4875 20.5625 13 19.3833 13 18C13 16.6167 13.4875 15.4375 14.4625 14.4625C15.4375 13.4875 16.6167 13 18 13C19.3833 13 20.5625 13.4875 21.5375 14.4625C22.5125 15.4375 23 16.6167 23 18C23 19.3833 22.5125 20.5625 21.5375 21.5375C20.5625 22.5125 19.3833 23 18 23ZM20.35 19.65L19.65 20.35L17.5 18.2V15H18.5V17.8L20.35 19.65Z" fill="currentColor"/>
<path d="M4 17V19H11.5764C11.5261 18.674 11.5 18.3401 11.5 18C11.5 17.6599 11.5261 17.326 11.5764 17H8V10C8 8.9 8.39167 7.95833 9.175 7.175C9.95833 6.39167 10.9 6 12 6C13.1 6 14.0417 6.39167 14.825 7.175C15.6083 7.95833 16 8.9 16 10V11.8135C16.6301 11.61 17.3022 11.5 18 11.5V10C18 8.61667 17.5833 7.3875 16.75 6.3125C15.9167 5.2375 14.8333 4.53333 13.5 4.2V3.5C13.5 3.08333 13.3542 2.72917 13.0625 2.4375C12.7708 2.14583 12.4167 2 12 2C11.5833 2 11.2292 2.14583 10.9375 2.4375C10.6458 2.72917 10.5 3.08333 10.5 3.5V4.2C9.16667 4.53333 8.08333 5.2375 7.25 6.3125C6.41667 7.3875 6 8.61667 6 10V17H4Z" fill="currentColor"/>
<path d="M11.8135 20C12.0307 20.6723 12.3545 21.2968 12.7649 21.8534C12.5297 21.9511 12.2747 22 12 22C11.45 22 10.9792 21.8042 10.5875 21.4125C10.1958 21.0208 10 20.55 10 20H11.8135Z" fill="currentColor"/>
</svg>
`;

  private iconCss = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M18 23C16.6167 23 15.4375 22.5125 14.4625 21.5375C13.4875 20.5625 13 19.3833 13 18C13 16.6167 13.4875 15.4375 14.4625 14.4625C15.4375 13.4875 16.6167 13 18 13C19.3833 13 20.5625 13.4875 21.5375 14.4625C22.5125 15.4375 23 16.6167 23 18C23 19.3833 22.5125 20.5625 21.5375 21.5375C20.5625 22.5125 19.3833 23 18 23ZM20.35 19.65L19.65 20.35L17.5 18.2V15H18.5V17.8L20.35 19.65Z" style="fill: var(--element-active-color)"/>
<path d="M4 17V19H11.5764C11.5261 18.674 11.5 18.3401 11.5 18C11.5 17.6599 11.5261 17.326 11.5764 17H8V10C8 8.9 8.39167 7.95833 9.175 7.175C9.95833 6.39167 10.9 6 12 6C13.1 6 14.0417 6.39167 14.825 7.175C15.6083 7.95833 16 8.9 16 10V11.8135C16.6301 11.61 17.3022 11.5 18 11.5V10C18 8.61667 17.5833 7.3875 16.75 6.3125C15.9167 5.2375 14.8333 4.53333 13.5 4.2V3.5C13.5 3.08333 13.3542 2.72917 13.0625 2.4375C12.7708 2.14583 12.4167 2 12 2C11.5833 2 11.2292 2.14583 10.9375 2.4375C10.6458 2.72917 10.5 3.08333 10.5 3.5V4.2C9.16667 4.53333 8.08333 5.2375 7.25 6.3125C6.41667 7.3875 6 8.61667 6 10V17H4Z" style="fill: var(--element-active-color)"/>
<path d="M11.8135 20C12.0307 20.6723 12.3545 21.2968 12.7649 21.8534C12.5297 21.9511 12.2747 22 12 22C11.45 22 10.9792 21.8042 10.5875 21.4125C10.1958 21.0208 10 20.55 10 20H11.8135Z" style="fill: var(--element-active-color)"/>
</svg>
`;

  override render() {
    return html`
      <div class="wrapper">${this.useCssColor ? this.iconCss : this.icon}</div>
    `;
  }

  static override styles = css`
    .wrapper {
      height: 100%;
      width: 100%;
      line-height: 0;
    }
    .wrapper > * {
      height: 100%;
      width: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'obi-alerts-shelf': ObiAlertsShelf;
  }
}
